var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorXRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4015_5420)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.25,
    fill: "white",
    stroke: "#E30000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2005 11.9731L15.8864 9.29415C16.243 8.93846 16.2514 8.41532 15.914 8.08237C15.5784 7.75109 15.084 7.73845 14.7054 8.1161L12.0193 10.7951L9.31305 8.09587C9.02448 7.80803 8.46024 7.7071 8.08403 8.08234C7.70781 8.45758 7.78404 8.9511 8.13091 9.29708L10.8313 11.9905C10.8313 11.9905 8.45434 14.3511 8.11714 14.6858C7.77995 15.0204 7.7126 15.5235 8.08305 15.893C8.4535 16.2626 9.00414 16.1681 9.30374 15.8693L12.0121 13.1679L14.8212 15.9698C15.0981 16.246 15.5623 16.2419 15.9137 15.8915C16.215 15.5909 16.2549 15.0555 15.9919 14.8021L13.2005 11.9731Z",
    fill: "#E30000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4015_5420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorXRed);
export default __webpack_public_path__ + "static/media/error-x-red.d59aee1643c5b81729c1dcadbe75e364.svg";
export { ForwardRef as ReactComponent };